import axios from "axios";

const axiosClient = axios.create({
	baseURL: process.env.REACT_APP_BASE_DEV_API,
	headers: {
		Accept: "application/json",
		"X-server-appid": "server",
		"X-server-appkey": "server",
	},
});

axiosClient.interceptors.request.use((config) => {
	const { sessionToken = "" } = JSON.parse(localStorage.getItem("user") ?? "{}");
	if (sessionToken) config.headers["X-server-session-token"] = sessionToken;
	return config;
});

export default axiosClient;
